var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.notifications.length)?_c('div',{staticClass:"notify"},_vm._l((_vm.notifications),function(x){return _c('v-alert',{key:x.id,staticClass:"notifyItem",attrs:{"type":x.tipo}},[_vm._v(" "+_vm._s(x.children)+" ")])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }